import React, { useState } from 'react';

import DateField from 'screens/common/sidepanel/DetailSection/DateField';
import styled, { css } from 'styled-components';
import { StyledButton, StyledTypography } from 'styles/common';

import BackSvg from 'assets/images/double-back.svg?react';

import theme from 'constants/theme';

const NavigationBar = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 1rem;
  border-bottom: 1px solid lightgrey;
`;

const NavItem = ({ children, isSelected = false, handleOnClick }) => (
  <StyledNavButton disableFocusRipple disableRipple onClick={handleOnClick} selected={isSelected} rightGutter={2}>
    {children}
  </StyledNavButton>
);

const blueBorderCSS = css`
  border-bottom: 3px solid ${(props) => props.theme.palette.primary.main};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

const StyledNavButton = styled(StyledButton)`
  border-bottom: 3px solid transparent;
  ${(props) => props.selected && blueBorderCSS};
`;

const IconContainer = styled.button`
  svg {
    fill: ${(props) => props.theme.palette.icons.grey};
    width: 100%;
    height: auto;
  }
  display: inline-flex;
  width: 28px;
  height: 20px;
  background: transparent;
  border: 1px solid transparent;
  outline: none;
  &:hover {
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.palette.icons.black};
      width: 100%;
      height: auto;
    }
  }
  ${(props) =>
    props.right &&
    css`
      transform: scaleX(-1);
    `}
`;

const COUNT_TO_DISPLAY = 3;

const TalkingPointCommentTabs = ({ data, selectedId = null, setSelectedId }) => {
  const reversedData = [...data].reverse();
  const [lastVisibleIndex, setlastVisibleIndex] = useState(data.length - 1);
  const hasMoreLeft = lastVisibleIndex - COUNT_TO_DISPLAY >= 0;
  const hasMoreRight = lastVisibleIndex + 1 <= data.length - 1;
  const maxThree =
    reversedData.length < 3
      ? reversedData
      : reversedData.slice(lastVisibleIndex + 1 - COUNT_TO_DISPLAY, lastVisibleIndex + 1);

  const moveLeft = () => {
    setlastVisibleIndex((lastVisibleIndex) =>
      lastVisibleIndex - COUNT_TO_DISPLAY >= COUNT_TO_DISPLAY - 1
        ? lastVisibleIndex - COUNT_TO_DISPLAY
        : COUNT_TO_DISPLAY - 1
    );
  };

  const moveRight = () => {
    setlastVisibleIndex((lastVisibleIndex) =>
      lastVisibleIndex + COUNT_TO_DISPLAY <= data.length - 1 ? lastVisibleIndex + COUNT_TO_DISPLAY : data.length - 1
    );
  };

  return (
    <NavigationBar>
      {hasMoreLeft && (
        <IconContainer onClick={moveLeft} hidden={!hasMoreLeft}>
          <BackSvg />
        </IconContainer>
      )}
      {maxThree.map(({ instanceId: id, dueTS, status }, index) => (
        <NavItem
          isSelected={id === selectedId}
          handleOnClick={() => {
            setSelectedId(id);
          }}
        >
          <StyledTypography
            variant="body2"
            color={index === selectedId ? theme.palette.primary.light : 'textSecondary'}
            cursor="pointer"
          >
            {status === 'Scheduled' ? 'Latest' : <DateField.DatePresentDisplay date={dueTS} weight={500} />}
          </StyledTypography>
        </NavItem>
      ))}
      {hasMoreRight && (
        <IconContainer onClick={moveRight} right hidden={!hasMoreRight}>
          <BackSvg />
        </IconContainer>
      )}
    </NavigationBar>
  );
};

export default TalkingPointCommentTabs;
